export const styles = {
  importChoices: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    '& .import-choices-btn': {
      height: '36px !important',
      minWidth: 'max-content !important',
    },
  },
};
